import { render } from "./detailProduct.vue?vue&type=template&id=40aeccd7&scoped=true"
import script from "./detailProduct.vue?vue&type=script&lang=js"
export * from "./detailProduct.vue?vue&type=script&lang=js"

import "./detailProduct.vue?vue&type=style&index=0&id=40aeccd7&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40aeccd7"]])

export default __exports__